module.exports = __webpack_public_path__ + "images/home-heaer.94c444ff.png";